<template>
  <div class="market-detail">
    <el-card v-if="item">
      <div class="detail-header">
        <h1>{{ item.name }}</h1>
        <el-tag :type="getTypeColor(item.type)">{{ getTypeName(item.type) }}</el-tag>
      </div>
      <div class="detail-meta">
        <span>分类: {{ item.category?.name || '无' }}</span>
        <span>下载: {{ item.download_count }}</span>
        <span>浏览: {{ item.view_count }}</span>
        <span>更新时间: {{ formatDate(item.updated_at) }}</span>
      </div>
      <div class="detail-tags">
        <el-tag v-for="tag in item.tags" :key="tag.id" style="margin-right: 5px;">
          {{ tag.name }}
        </el-tag>
      </div>
      <div class="detail-description" v-html="formatDescription(item.description)"></div>
      <div class="detail-version-requirement" v-if="item.version_requirement">
        <el-alert
          :title="`版本要求: ${item.version_requirement}`"
          type="info"
          :closable="false"
          show-icon
        />
      </div>
      <div class="detail-actions">
        <el-button type="primary" size="large" @click="handleDownload" v-if="item.file_url">
          下载资源
        </el-button>
        <el-button @click="$router.back()">返回</el-button>
      </div>
    </el-card>
    <el-skeleton v-else :rows="10" animated />
  </div>
</template>

<script>
import api from '../api'

export default {
  name: 'MarketDetail',
  data() {
    return {
      item: null
    }
  },
  mounted() {
    this.loadDetail()
  },
  methods: {
    async loadDetail() {
      try {
        const id = this.$route.params.id
        const response = await api.get(`/market/items/${id}/`)
        this.item = response.data
      } catch (error) {
        this.$message.error('加载详情失败')
        this.$router.back()
      }
    },
    async handleDownload() {
      try {
        if (this.item.file_url) {
          // 先更新下载计数
          try {
            await api.post(`/market/items/${this.item.id}/download/`)
          } catch (error) {
            console.error('更新下载计数失败:', error)
          }
          // 打开文件URL
          window.open(this.item.file_url, '_blank')
          this.$message.success('开始下载')
        } else {
          this.$message.warning('该资源没有可下载的文件')
        }
      } catch (error) {
        this.$message.error('下载失败')
      }
    },
    getTypeName(type) {
      const map = {
        app: '应用',
        knowledge: '知识库',
        tool: '工具',
        mcp: 'MCP'
      }
      return map[type] || type
    },
    getTypeColor(type) {
      const map = {
        app: 'success',
        knowledge: 'info',
        tool: 'warning',
        mcp: 'danger'
      }
      return map[type] || ''
    },
    formatDate(dateString) {
      const date = new Date(dateString)
      return date.toLocaleString('zh-CN')
    },
    formatDescription(text) {
      if (!text) return ''
      return text.replace(/\n/g, '<br>')
    }
  }
}
</script>

<style scoped>
.market-detail {
  max-width: 900px;
  margin: 0 auto;
}

.detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.detail-header h1 {
  margin: 0;
  flex: 1;
}

.detail-meta {
  margin-bottom: 15px;
  color: #909399;
  font-size: 14px;
}

.detail-meta span {
  margin-right: 20px;
}

.detail-tags {
  margin-bottom: 20px;
}

.detail-description {
  margin-bottom: 30px;
  line-height: 1.8;
  color: #606266;
  min-height: 100px;
}

.detail-version-requirement {
  margin-bottom: 20px;
}

.detail-actions {
  display: flex;
  gap: 10px;
}
</style>

